import { Component } from '@angular/core';

@Component({
  selector: 'app-enterprise-ai-dashboard',
  templateUrl: './enterprise-ai-dashboard.component.html',
  styleUrls: ['./enterprise-ai-dashboard.component.scss'],
})
export class EnterpriseAiDashboardComponent {}
